// RulerOverlay.jsx
import React, { Component } from "react";
import { registerRuler } from "./ruler-manager";
import rulerImage from "../../assets/images/ruler-scale.svg";

class RulerOverlay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      left: 600,
      top: 200,
      angle: 180,
      dragging: false,
      rotating: false
    };
  }

  componentDidMount() {
    registerRuler(this);

    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);
  }

  componentWillUnmount() {
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("mouseup", this.onMouseUp);
  }

  toggle = () => {
    this.setState({ visible: !this.state.visible });
  };

  toggleReset = () => {
    this.setState({ 
        visible: false,
        left: 600,
        top: 200,
        angle: 180,
    });
  };

  onMouseDown = (e) => {
    if (e.target.classList.contains("rotate-handle")) {
      this.setState({ rotating: true });
      return;
    }

    this.dragging = true;
    this.startX = e.clientX;
    this.startY = e.clientY;

    this.initialLeft = this.state.left;
    this.initialTop = this.state.top;
  };

  onMouseMove = (e) => {
    // Drag
    if (this.dragging) {
      const dx = e.clientX - this.startX;
      const dy = e.clientY - this.startY;

      this.setState({
        left: this.initialLeft + dx,
        top: this.initialTop + dy
      });
    }

    // Rotate
    if (this.state.rotating) {
      const rect = this.ruler.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;

      const angle =
        (Math.atan2(e.clientY - cy, e.clientX - cx) * 180) / Math.PI;

      this.setState({ angle });
    }
  };

  onMouseUp = () => {
    this.dragging = false;
    this.setState({ rotating: false });
  };

  render() {
    if (!this.state.visible) return null;

    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 999999,
          pointerEvents: "none"
        }}
      >
        <div
          ref={(el) => (this.ruler = el)}
          onMouseDown={this.onMouseDown}
          style={{
            position: "absolute",
            left: this.state.left,
            top: this.state.top,
            width: 600,
            height: 80,
            background: `url(${rulerImage}) no-repeat`,
            backgroundSize: "100% 100%",
            cursor: "grab",
            pointerEvents: "auto",
            transform: `rotate(${this.state.angle}deg) scale(1.3)`,
            transformOrigin: "center center",
            opacity: 0.85,
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            borderRadius: '10px',
          }}
        >
          {/* Rotate Handle */}
          <div
            className="rotate-handle"
            style={{
              position: "absolute",
              right: -20,
              top: "50%",
              width: 16,
              height: 16,
              background: "#333",
              borderRadius: "50%",
              cursor: "crosshair",
              transform: "translateY(-50%)"
            }}
          />
        </div>
      </div>
    );
  }
}

export default RulerOverlay;